import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import SilentVideo from '@src/components/silent-video';
import Link from '@src/components/link';
import Page from '../../components/page';

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <div className={styles['canvas']}>
        {/*  bg: 背景  */}
        <div className={styles['bg']} role="img" aria-label="背景" />
        <div className={styles.kvVideo}>
          <SilentVideo cover={store.kvImage} src={store.kvVideo} />
        </div>
        {/*  logo  */}
        <Link href={store.gameIndexUrl} target={'_blank'} className={styles['logo']} aria-label="logo" />
        {/*  nav-list: 导航列表  */}
        <div className={styles['nav-list']}>
          {store.btnColumnList.map((item, idx) => (
            <Link key={item.name} onClick={() => store.clickCol(item)} className={styles[`nav-item-${idx + 1}`]} aria-label="导航" />
          ))}
        </div>
      </div>
    </Page>
  );
};

export default observer(Main);
